// @flow

import getDeclineReasons from './getDeclineReasons'

export default [
  ...getDeclineReasons,
]
